export function calendarListByFilter(filter) {
  const query = `{ calendarListByFilter(filter: ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')}){  id, name, colorHexa, visibility }}`;
  return query;
}

export function calendarNotificationListByCalendarId(filter) {
  const query = `{ calendarNotificationListByCalendarId(filter: ${JSON.stringify(
    filter
  ).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}){  id, typeNotification, timeNotification }}`;
  return query;
}

export function saveCalendarMutation(values) {
  let notifications = [];
  if (values.calendarNotifications) {
    const notificationsValid = values.calendarNotifications.filter(
      (item) => item.timeNotification >= 0 && item.typeNotification !== ''
    );
    notifications = notificationsValid.map((item) => ({
      id: item.id ? item.id : 0,
      typeNotification: item.typeNotification,
      timeNotification: item.timeNotification,
      filterByStatus: false,
      updaterId: 0,
    }));
  }
  const regexExp = new RegExp(/^#[0-9A-F]{3,6}$/i);
  const mutationQuery = `mutation{    
    calendarSave(calendar: {
                    id: ${values.id ? values.id : 0},
                    name: "${values.name}",
                    colorHexa: "${
                      regexExp.test(values.colorHexa)
                        ? values.colorHexa
                        : '#5300eb'
                    }",
                    visibility: "${values.visibility.value}",
                    calendarNotifications: ${JSON.stringify(
                      notifications
                    ).replace(/"([^(")"]+)":/g, '$1:')}                    
            }){id}
  }`;
  return mutationQuery;
}

export function eventCalendarFindByCommunicationId(communicationId) {
  return `{ eventCalendarFindById(filter: {id: ${communicationId}}) {
        id
        communication {
          id
          title
          htmlContent
          createdAt
          relatedObjects {
            id
            description
            quantity
            type
          }
        }
        repeat
        lstNotifications {
          id
          typeNotification
          timeNotification
        }
        local
        allDay
        initialDate
        initialHour
        finalDate
        finalHour
        repeat
        daysRepeat
        inicialDateRepeat
        finalDateRepeat
        fatherCode
        attendanceConfirmation
        calendar{ id name colorHexa }
    }
 }`;
}

export function eventCalendarListByFilter(period, calendars) {
  const query = `{ eventCalendarListByFilter(filter:${JSON.stringify(
    period
  ).replace(/"([^(")"]+)":/g, '$1:')}, calendars: ${JSON.stringify(
    calendars
  ).replace(/"([^(")"]+)":/g, '$1:')}){
    dateEventCalendar,
    lstEventCalendar{ id, local, allDay, initialDate, initialHour, finalDate, finalHour, repeat, daysRepeat, inicialDateRepeat, finalDateRepeat, fatherCode, attendanceConfirmation
    calendar{id,name, colorHexa}
    communication {
      id
      title
      content
      htmlContent
    }
  }
 }
}`;
  return query;
}

export function saveEventMutation(values) {
  const event = {
    ...values,
  };

  const relatedObjects = event.relatedObjects.map((item) => ({
    id: item.id,
    description: item.description,
    type: item.type,
    quantity: item.quantity,
  }));

  let lstNotifications = [];
  if (event.lstNotifications) {
    lstNotifications = event.lstNotifications.map((item) => ({
      id: item.id ? item.id : 0,
      typeNotification: item.typeNotification,
      timeNotification: item.timeNotification,
    }));
  }

  if (event.repeat) {
    if (event.daysRepeat) {
      event.daysRepeat = event.daysRepeat.toString().replace(/,/g, ';');
    } else {
      event.repeat = false;
      event.daysRepeat = '0;0;0;0;0;0;0';
      event.inicialDateRepeat = 0;
      event.finalDateRepeat = 0;
    }
  } else {
    event.daysRepeat = '0;0;0;0;0;0;0';
    event.inicialDateRepeat = 0;
    event.finalDateRepeat = 0;
  }

  if (!event.inicialDateRepeat && !event.finalDateRepeat) {
    event.inicialDateRepeat = 0;
    event.finalDateRepeat = 0;
  }

  if (event.allDay) {
    event.startHour = '';
    event.endHour = '';
  }

  const mutationQuery = `mutation($title: String!, $description: String!, $local: String){
    eventsCalendarSave(eventsCalendar:[{
                    id: ${event.id ? event.id : 0},
                    calendar:{id: ${event.calendar.value}},
                    name: $title,
                    description: $description,
                    local: $local,
                    allDay: ${!!values.allDay},
                    initialDate: ${event.start.getTime()},
                    initialHour:"${event.startHour}",
                    finalDate: ${event.end.getTime()},
                    finalHour: "${event.endHour}",
                    repeat: ${event.repeat},
                    daysRepeat: "${event.daysRepeat};",
                    inicialDateRepeat: ${
                      event.inicialDateRepeat !== 0
                        ? event.inicialDateRepeat.getTime()
                        : event.inicialDateRepeat
                    },
                    finalDateRepeat: ${
                      event.finalDateRepeat !== 0
                        ? event.finalDateRepeat.getTime()
                        : event.finalDateRepeat
                    },
                    fatherCode: ${event.fatherCode ? event.fatherCode : 0},
                    attendanceConfirmation: ${event.requestPresence},
                    relatedObjects: ${JSON.stringify(relatedObjects).replace(
                      /"([^(")"]+)":/g,
                      '$1:'
                    )},
                    lstNotifications: ${JSON.stringify(
                      lstNotifications
                    ).replace(/"([^(")"]+)":/g, '$1:')},
                    saveAll: ${values.saveAll || false},
                    filterByStatus: false,
                    updaterId: 0
    }]){eventsCalendar:id}
}`;
  return mutationQuery;
}

export function removeCalendarMutation(id) {
  const query = `mutation {calendarRemove(id: ${id})}`;
  return query;
}

export function removeEventMutation(id, deleteChildren) {
  const query = `mutation{ deleteEventCalendar(id:${id}, deleteChildren:${deleteChildren})}`;
  return query;
}

export function attendanceCalendarEventConfirmationListByEventId(eventId) {
  const query = ` {
    attendanceCalendarEventConfirmationListByEventId(
      eventId: ${eventId}) {
        responsableName,
        responsableCellPhone,
        responsableCellPhone1,
        responsablePhone,
        responsableEmail,
        responsabilities,
        confirmationStatus,        
        confirmationDate,
        readBy
      }    
  }`;

  return query;
}
